import React from "react";
import Meta from "../components/Meta";
import ContactSection from "../components/ContactSection";

function ContactPage(props) {
  return (
    <>
      <Meta title="About" description="Learn about our company and team" />
      <section className="py-12 px-4">
        <div className="container mx-auto">
          <ContactSection />
        </div>
      </section>
    </>
  );
}

export default ContactPage;
